import {CatalogConfig} from '../types'
import {communityCatalogConfigs} from './communityCatalogs'
import {experienceBeneficiariesConfig} from './experienceBeneficiaries'
import {experienceCatalogConfigs} from './experienceCatalogs'
import {geoCatalogConfigs} from './geoCatalogs'
import {memberBalancesConfig} from './memberBalances'
import {memberCatalogConfigs} from './memberCatalogs'
import {moderationCatalogConfigs} from './moderationCatalogs'
import {sensitiveFieldsConfig} from './sensitiveFields'
import {waitinglistCatalogConfigs} from './waitinglistCatalogs'

// Registry of catalogs served by the generic /admin/catalog/:slug screen. Phase B adds a new
// entry here (and a menu item) per catalog — no new page/route code.
export const catalogConfigs: CatalogConfig[] = [
  experienceBeneficiariesConfig,
  ...experienceCatalogConfigs,
  ...memberCatalogConfigs,
  ...moderationCatalogConfigs,
  ...communityCatalogConfigs,
  ...waitinglistCatalogConfigs,
  ...geoCatalogConfigs,
  memberBalancesConfig,
  sensitiveFieldsConfig,
]

export const getCatalogConfig = (slug: string): CatalogConfig | undefined =>
  catalogConfigs.find((config) => config.slug === slug)
